import { Link } from 'react-router-dom'
import { Linkedin } from 'lucide-react'

const footerLinks = {
  Services: [
    { label: 'Tech Leadership Search', href: '/services' },
    { label: 'GCC Talent Setup & Scaling', href: '/gcc-practice' },
    { label: 'Data Science Leadership', href: '/capabilities' },
    { label: 'Product Leadership', href: '/capabilities' },
  ],
  Capabilities: [
    { label: 'Technology Architecture', href: '/capabilities' },
    { label: 'AI & Machine Learning', href: '/capabilities' },
    { label: 'Founding Teams', href: '/gcc-practice' },
    { label: '4-Factor Assessment', href: '/services' },
  ],
  Company: [
    { label: 'About', href: '/about' },
    { label: 'Insights', href: '/insights' },
    { label: 'Contact', href: '/contact' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms', href: '/terms' },
  ],
}

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white py-20 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16 pb-16 border-b border-white/10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-6 group">
              <span className="text-white text-xl font-heading font-bold tracking-tight group-hover:text-white/80 transition-colors duration-200">
                Strive Partners
              </span>
            </Link>
            <p className="text-white/40 text-sm font-body leading-relaxed max-w-xs mb-6">
              Specialist tech and GCC search firm. From the founding leader to the teams that make the centre succeed.
            </p>
            <a
              href="mailto:sahil@strivepartners.co"
              className="text-xs text-white/50 hover:text-white transition-colors font-body tracking-wide"
              data-testid="footer-email"
            >
              sahil@strivepartners.co
            </a>
          </div>

          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <p className="text-[9px] tracking-[0.25em] uppercase text-white/25 mb-6 font-body font-semibold">
                {section}
              </p>
              <ul className="space-y-3">
                {links.map(link => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-xs text-white/50 hover:text-white transition-colors font-body"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="text-[10px] text-white/25 font-body">
              &copy; {new Date().getFullYear()} Strive Partners. All rights reserved. Bengaluru, India.
            </p>
            <p className="text-[10px] text-white/20 mt-1 font-body">
              Technology-enabled by{' '}
              <a href="https://strivehunt.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-white/40 transition-colors">
                Strive Hunt
              </a>
              {' '}&middot;{' '}
              <a href="https://strivehunt.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/40 transition-colors">
                Browse Open Roles
              </a>
              {' '}&middot;{' '}
              <a href="https://strivehunt.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/40 transition-colors">
                Client Login
              </a>
            </p>
          </div>
          <a
            href="https://linkedin.com/company/strive-partners"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="text-white/30 hover:text-white transition-colors"
            aria-label="Strive Partners on LinkedIn"
          >
            <Linkedin size={16} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </footer>
  )
}
